import "./Reviews.css";
import Card, { CardHead } from "../Card/Card";
import Avatar from "../Avatar/Avatar";

export default function Reviews(props) {
  const reviews = props.reviews || [];
  const showAvatars = props.showAvatars !== false;

  if (!reviews.length && !props.showPlaceholder) return null;

  return (
    <Card className="reviews">
      <CardHead
        eyebrow="From the mentors"
        title="Reviews"
        description="Written as mentors read your work."
      />

      {reviews.length ? (
        <ul
          className="reviews-list col"
          tabIndex={0}
          role="group"
          aria-label="Mentor reviews"
        >
          {reviews.map((r) => (
            <li key={r.id} className="review col">
              <div className="review-head row">
                <Avatar
                  src={showAvatars ? r.avatarUrl : null}
                  name={r.author}
                  size="sm"
                />
                <span className="review-author t-label">{r.author}</span>
                <span className="review-at t-mono">{r.at}</span>
              </div>
              <p className="review-body t-body-sm">{r.body}</p>
            </li>
          ))}
        </ul>
      ) : (
        <p className="reviews-empty t-body-sm t-dimmer">
          Mentor reviews will appear here.
        </p>
      )}
    </Card>
  );
}
